const r = (e) => {
  console.error("[runDetached] Unhandled promise rejection:", e);
}, n = (e, o = r) => {
  e.catch((c) => {
    try {
      o(c);
    } catch (t) {
      r(c), r(t);
    }
  });
};
export {
  n as runDetached
};
//# sourceMappingURL=runDetached.js.map
